var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _text, _g22, _g23, _g24, _g25, _g26, _g27, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g28, _g29, _g30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorking4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: "-218.5,-240.067  -206.359,-240.067 -206.359,-235.746 -218.5,-235.746  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: "-218.5,-224.866  -199.83,-224.866 -199.83,-217.704  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -204.152,
    y1: -214.665,
    x2: -218.5,
    y2: -214.665
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: "-218.5,-211.196  -210.514,-211.196 -208.975,-212.97 -209.937,-214.665 -218.5,-214.665  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: "-206.359,-240.067  -218.5,-237.823 -206.359,-235.746  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: "M-200.309-235.746 c-1.801-2.324-2.691-4.196-6.05-4.321"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -199.83,-224.866 -196.839,-228.029 -199.626,-234.865  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-200.533-210.448c2.017,0,3.662-1.645,3.662-3.662s-1.646-3.661-3.662-3.661s-3.661,1.645-3.661,3.661 S-202.549-210.448-200.533-210.448z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-218.5-204.792h14.079v5.329c0,0.841,0.689,1.53,1.53,1.53h9.387c0.839,0,1.53-0.69,1.53-1.53v-18.49l-2.245-4.669"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -191.974,-217.953 -196.872,-214.109 -191.974,-200.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -199.83,-218.439 -194.219,-222.622 -196.839,-228.029 -199.83,-224.866  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-194.219-222.622c1.582-0.05,3.018-0.698,4.361-1.734c0.297-1.397,0.009-2.617-0.816-3.673h-6.166L-194.219-222.622z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -211.052,-214.665 -218.5,-217.623 -199.83,-224.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -204.421,-204.792 -204.152,-214.665 -210.514,-211.196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -218.5,-209.054 -210.514,-211.196 -204.421,-204.792  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -204.397,-205.637 -200.385,-210.451 -204.427,-200.631  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -196.872,-214.109 -191.974,-200.177 -200.385,-210.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -199.83,-224.866 -203.025,-233.116 -200.309,-235.746 -199.626,-234.865  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -206.359,-235.746 -204.936,-235.746 -203.025,-233.116  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -200.309,
    y1: -235.746,
    x2: -204.935,
    y2: -235.746
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -218.5,-240.067 -230.641,-240.067 -230.641,-235.746 -218.5,-235.746  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -218.5,-224.866 -237.17,-224.866 -237.17,-217.704  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -232.847,
    y1: -214.665,
    x2: -218.5,
    y2: -214.665
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -218.5,-211.196 -226.485,-211.196 -228.025,-212.97 -227.064,-214.665 -218.5,-214.665  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -230.641,-240.067 -218.5,-237.823 -230.641,-235.746  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-236.691-235.746c1.802-2.324,2.691-4.196,6.051-4.321"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -237.17,-224.866 -240.161,-228.029 -237.374,-234.865  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-236.467-210.448c2.017,0,3.662-1.645,3.662-3.662s-1.645-3.661-3.662-3.661s-3.662,1.645-3.662,3.661 S-238.483-210.448-236.467-210.448z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-218.5-204.792h-14.079v5.329c0,0.841-0.69,1.53-1.531,1.53h-9.386c-0.84,0-1.53-0.69-1.53-1.53v-18.49l2.245-4.669"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -245.026,-217.953 -240.128,-214.109 -245.026,-200.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -237.17,-218.439 -242.781,-222.622 -240.161,-228.029 -237.17,-224.866  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-242.781-222.622c-1.581-0.05-3.018-0.698-4.361-1.734c-0.297-1.397-0.009-2.617,0.816-3.673h6.166L-242.781-222.622z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -225.947,-214.665 -218.5,-217.623 -237.17,-224.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -232.579,-204.792 -232.847,-214.665 -226.485,-211.196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -218.5,-209.054 -226.485,-211.196 -232.579,-204.792  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -232.602,-205.637 -236.614,-210.451 -232.573,-200.631  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -240.128,-214.109 -245.026,-200.177 -236.614,-210.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -237.17,-224.866 -233.976,-233.116 -236.691,-235.746 -237.374,-234.865  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -230.641,-235.746 -232.064,-235.746 -233.976,-233.116  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -236.691,
    y1: -235.746,
    x2: -232.065,
    y2: -235.746
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -134.5,
    y1: -229.166,
    x2: -134.5,
    y2: -189.955
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-134.5-229.166l-23.218,10.621c0.07,14.264,9.804,22.563,23.218,28.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -134.5,-189.955 -157.718,-218.545 -134.5,-218.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -141.54,-233.858 -151.358,-224.102 -134.5,-231.697 -137.711,-233.858  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -151.358,-224.102 -151.358,-233.92 -146.542,-233.92 -146.542,-242.318 -141.54,-237.316 -141.54,-233.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -146.542,-242.318 -138.236,-242.318 -138.236,-237.316 -141.54,-237.316  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -138.236,
    y1: -241.345,
    x2: -136.453,
    y2: -237.316
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -138.236,
    y1: -237.316,
    x2: -138.236,
    y2: -233.858
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-134.5-229.166l23.218,10.621c-0.07,14.264-9.805,22.563-23.218,28.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -134.5,-189.955 -111.282,-218.545 -134.5,-218.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -127.461,-233.858 -117.643,-224.102 -134.5,-231.697 -131.289,-233.858  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -117.643,-224.102 -117.643,-233.92 -122.459,-233.92 -122.459,-242.318 -127.461,-237.316 -127.461,-233.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -122.459,-242.318 -130.764,-242.318 -130.764,-237.316 -127.461,-237.316  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -130.764,
    y1: -241.345,
    x2: -132.547,
    y2: -237.316
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -130.764,
    y1: -237.316,
    x2: -130.764,
    y2: -233.858
  }), /*#__PURE__*/React.createElement("rect", {
    x: -138.236,
    y: -248.045,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 7.473,
    height: 5.728
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -135.944,-233.846 -136.453,-237.316 -132.547,-237.316 -133.055,-233.85  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -141.54,
    y: -237.316,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 14.079,
    height: 3.458
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -46.571,-234.623 -52.183,-232.109 -43.164,-239.939  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -46.571,-234.623 -40.958,-237.137 -49.361,-229.841  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-37.872-236.37c3.14,0,5.702-2.562,5.702-5.703c0-3.141-2.563-5.703-5.702-5.703c-3.143,0-5.704,2.562-5.704,5.703 C-43.576-238.932-41.015-236.37-37.872-236.37z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -31.167,-232.139 -27.035,-226.775 -32.595,-239.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -31.167,-232.139 -35.001,-236.945 -30.462,-225.811  "
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-30.557-216.409c-1.467-1.032-2.426-2.739-2.426-4.669c0-3.149,2.553-5.703,5.702-5.703s5.704,2.553,5.704,5.703 c0,1.016-0.267,1.97-0.73,2.796"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -43.837,-211.912 -49.143,-220.038 -46.032,-209.65  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -30.53,
    y1: -216.391,
    x2: -27.035,
    y2: -226.775
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -30.462,
    y1: -225.811,
    x2: -22.351,
    y2: -218.206
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -32.917,
    y1: -220.209,
    x2: -21.944,
    y2: -223.097
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -30.557,
    y1: -216.409,
    x2: -22.351,
    y2: -218.206
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-22.351-218.206l-13.696,12.373c-1.378-0.438-2.072-1.275-1.579-2.806l7.096-7.752"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-36.047-205.833l9.703,0.41c2.242-0.102,4.095-0.545,4.506-3.043l-0.469-9.816"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -30.53,
    y1: -216.391,
    x2: -21.87,
    y2: -209.131
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -30.53,
    y1: -216.391,
    x2: -26.812,
    y2: -205.443
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -37.626,
    y1: -208.638,
    x2: -21.87,
    y2: -209.131
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -43.164,-239.939 -38.035,-238.159 -32.595,-239.912  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -37.872,
    y1: -247.776,
    x2: -38.152,
    y2: -236.373
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -43.508,
    y1: -242.798,
    x2: -32.154,
    y2: -242.328
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -35.001,-236.945 -38.035,-238.159 -40.958,-237.137  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -61.36,
    y: -231.554,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 9.178,
    height: 4.034
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -49.361,-229.841 -52.183,-227.52 -49.143,-220.038  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -61.36,
    y1: -231.554,
    x2: -52.183,
    y2: -227.52
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -49.361,-229.841 -43.998,-218.459 -49.143,-220.038  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -43.998,-218.459 -43.837,-211.913 -49.143,-220.038  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-69.778-209.515h23.384c5.306,0,9.646,4.34,9.646,9.645l0,0c0,5.305-4.34,9.646-9.646,9.646h-23.384 c-5.304,0-9.646-4.34-9.646-9.646l0,0C-79.424-205.175-75.082-209.515-69.778-209.515z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -68.375,-190.224 -68.375,-209.515 -79.424,-199.87  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-58.086-194.797c-2.681,0-4.853-2.172-4.853-4.852c0-2.68,2.172-4.852,4.853-4.852c0.017,0,0.034,0,0.052,0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-68.375-194.797c2.673,0,4.852-2.179,4.852-4.852c0-2.673-2.179-4.852-4.852-4.852c-2.672,0-4.852,2.179-4.852,4.852 C-73.227-196.977-71.047-194.797-68.375-194.797z"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -79.424,
    y1: -199.87,
    x2: -58.086,
    y2: -199.87
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -58.043,-194.797 -68.375,-194.797 -68.375,-204.501 -58.072,-204.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -63.528,-199.87 -68.375,-204.501 -73.222,-199.87 -68.375,-194.797  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -68.375,-209.515 -58.086,-207.008 -68.375,-204.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -68.375,-194.797 -58.086,-194.797 -68.375,-190.224  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -47.798,-190.224 -47.798,-209.515 -36.749,-199.87  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-58.086-194.796c2.68,0,4.852-2.172,4.852-4.853c0-2.679-2.172-4.852-4.852-4.852c-0.018,0-0.035,0-0.053,0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-47.798-194.796c2.673,0,4.852-2.179,4.852-4.853c0-2.671-2.179-4.852-4.852-4.852c-2.672,0-4.852,2.18-4.852,4.852 C-52.649-196.976-50.47-194.796-47.798-194.796z"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -36.749,
    y1: -199.87,
    x2: -58.086,
    y2: -199.87
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -58.13,-194.796 -47.798,-194.796 -47.798,-204.5 -58.1,-204.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -52.645,-199.87 -47.798,-204.5 -42.951,-199.87 -47.798,-194.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -47.798,-209.515 -58.086,-207.008 -47.798,-204.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -47.798,-194.796 -58.086,-194.796 -47.798,-190.224  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -72.409,-225.05 -64.984,-225.05 -68.375,-209.515 -72.817,-209.702  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-64.984-225.05l3.976,0.993l-0.352-4.91h-3.422L-64.984-225.05L-64.984-225.05z M-64.621-231.48l3.261-0.073v2.587h-3.422 L-64.621-231.48z"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -72.493,
    y1: -221.888,
    x2: -68.098,
    y2: -209.448
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -61.009,-224.057 -58.599,-220.081 -69.122,-225.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -49.143,-220.038 -68.122,-209.515 -58.599,-220.081  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -47.798,-209.515 -58.599,-220.081 -72.771,-211.432  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -53.238,-199.87 -58.086,-204.5 -62.933,-199.87 -58.086,-194.796  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-194.864-164.107L-194.864-164.107c1.119,0,2.034,0.915,2.034,2.034v46.993c0,1.12-0.915,2.035-2.034,2.035l0,0 c-1.119,0-2.034-0.915-2.034-2.035v-46.993C-196.898-163.192-195.983-164.107-194.864-164.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-192.83-145.143c1.874,1.133,3.087,3.713,3.087,6.566c0,2.835-1.199,5.405-3.057,6.547"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-196.898-161.021c-9.911,8.405-20.014,12.403-30.299,12.204h-10.661l-1.489,2.579v8.363 M-196.898-115.765 c-9.911-8.405-20.014-12.403-30.299-12.204h-10.661l-1.489-2.578v-7.33"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -196.898,
    y1: -161.021,
    x2: -221.998,
    y2: -127.709
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -238.603,
    y1: -147.528,
    x2: -222.873,
    y2: -127.803
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -223.846,-148.901 -197.599,-137.849 -237.858,-127.968  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -237.858,-148.817 -241.365,-148.817 -243.119,-147.063 -243.119,-137.849  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -237.858,-127.968 -241.365,-127.968 -243.119,-129.722 -243.119,-137.849  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -237.858,-127.968 -223.971,-123.988 -221.998,-127.709  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -237.858,-127.968 -237.718,-125.111 -235.333,-122.305 -231.125,-106.594 -229.301,-105.893 -222.568,-105.893 -220.955,-107.506  -223.971,-123.988  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -223.971,-123.988 -228.6,-105.893 -221.365,-109.747 -235.006,-121.083  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -247.257,
    y: -145.451,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 4.138,
    height: 14.308
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -247.256,
    y1: -142.786,
    x2: -243.119,
    y2: -132.545
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -237.858,
    y1: -148.817,
    x2: -243.119,
    y2: -139.419
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -243.119,
    y1: -136.333,
    x2: -237.858,
    y2: -127.968
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -112.713,-145.775 -134.763,-143.525 -108.063,-156.875 -111.663,-150.875 -106.713,-151.925  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-134.763-143.525c-11.468-1.387-19.282-5.412-23.55-12c1.495,12.271,5.755,23.479,12.45,33.751"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-158.313-155.525c-3.546,5.397-1.457,13.293,3.201,14.538l-5.151-0.288c0.323,6.269,3.361,9.403,8.884,9.672l-4.534,1.729 c2.018,4.922,5.633,7.179,10.051,8.101"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -160.263,
    y1: -141.275,
    x2: -151.379,
    y2: -131.604
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -155.913,
    y1: -129.875,
    x2: -145.862,
    y2: -121.774
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-112.713-145.775c-0.911,23.745-14.559,33.92-33.453,33.24c-5.109-0.185-12.269-2.328-16.121-4.557 c6.813-0.037,12.136-0.997,15.749-4.232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-115.383-153.215c-7.936-9.335-22.246-2.18-19.38,9.689"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -115.383,-153.215 -123.504,-119.282 -145.862,-121.774  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -111.663,-150.875 -134.763,-143.525 -123.504,-119.282 -155.111,-140.987 -134.763,-143.525 -145.862,-121.774  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-74.275-157.488h47.551c2.063,0,3.75,1.688,3.75,3.75v42.9c0,2.063-1.688,3.75-3.75,3.75h-47.551c-2.063,0-3.75-1.688-3.75-3.75 v-42.9C-78.025-155.8-76.338-157.488-74.275-157.488z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -78.025,-142.788 -22.975,-142.788 -38.566,-150.888 -62.436,-150.888  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-65.275-149.413c0-4.119,0-7.672,0-11.791c1.17-2.426,3.855-2.125,4.801,0v10.316"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-35.371-149.413c0-4.119,0-7.672,0-11.791c-1.17-2.426-3.855-2.125-4.801,0v10.316"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -78.025,
    y1: -142.788,
    x2: -26.725,
    y2: -107.088
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -22.975,-142.788 -78.025,-112.488 -26.725,-107.088  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -72.588,
    y1: -157.488,
    x2: -78.025,
    y2: -144.205
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -32.537,
    y1: -157.488,
    x2: -22.975,
    y2: -152.538
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -78.025,-142.788 -49.639,-148.188 -22.975,-142.788  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -38.566,-150.888 -49.639,-148.188 -62.436,-150.888  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-197.676-78.656l-9.512,8.998h-24.809c-0.849,0-1.543,0.693-1.543,1.542v27.122c0,0.849,0.694,1.543,1.543,1.543h37.534 c0.849,0,1.542-0.694,1.542-1.543v-27.122c0-0.849-0.694-1.542-1.542-1.542h-3.213V-78.656z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -194.463,-69.658 -212.716,-51.406 -222.613,-46.779 -233.54,-62.203 -210.017,-69.658 -206.545,-62.332 -197.676,-78.656  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-239.323-23.344l9.512-8.998h24.808c0.849,0,1.543-0.694,1.543-1.543v-27.121c0-0.849-0.695-1.543-1.543-1.543h-37.533 c-0.849,0-1.543,0.694-1.543,1.543v27.121c0,0.849,0.694,1.543,1.543,1.543h3.213V-23.344z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -233.54,-62.549 -244.08,-59.632 -239.323,-32.342 -230.582,-39.451 -222.741,-55.904 -212.716,-51.406  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -192.92,
    y1: -40.994,
    x2: -203.46,
    y2: -58.347
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -230.582,
    y1: -39.451,
    x2: -203.46,
    y2: -33.885
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -222.741,
    y1: -55.904,
    x2: -222.613,
    y2: -46.779
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -149.357,
    y: -79.935,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 13.55,
    height: 7.838
  }), /*#__PURE__*/React.createElement("rect", {
    x: -135.807,
    y: -79.004,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 3.853,
    height: 5.845
  }), /*#__PURE__*/React.createElement("rect", {
    x: -131.954,
    y: -78.34,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 6.709,
    height: 4.517
  }), /*#__PURE__*/React.createElement("rect", {
    x: -125.245,
    y: -79.07,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 1.395,
    height: 5.978
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-116.553-74.521c0.675,0.958,1.761,1.562,2.931,1.562c1.871,0,3.388-1.518,3.388-3.388c0-1.871-1.517-3.388-3.388-3.388 c-1.141,0-2.204,0.574-2.83,1.609l-2.784,0.081c-0.492-0.567-1.206-0.894-1.957-0.894c-1.432,0-2.591,1.16-2.591,2.591 s1.159,2.591,2.591,2.591c0.673,0,1.318-0.263,1.802-0.729L-116.553-74.521z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-112.424-64.938l1.063-0.042c0.337,0,0.612-0.275,0.612-0.613v-1.684c0-0.336-0.275-0.612-0.612-0.612h-4.899 c-0.337,0-0.613,0.276-0.613,0.612v1.684c0,0.338,0.276,0.613,0.613,0.613l1.156,0.042l0.009,4.236 c-1.579-1.042-2.712-3.876-2.712-7.209c0-2.518,0.646-4.751,1.644-6.143c0.666,0.683,1.575,1.095,2.541,1.095 c0.921,0,1.757-0.368,2.366-0.965c0.945,1.398,1.553,3.572,1.553,6.013c0,3.333-1.133,6.167-2.712,7.209L-112.424-64.938z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -117.788,-68.655 -116.796,-69.88 -110.824,-69.88 -109.754,-69.127  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -116.03,
    y1: -69.88,
    x2: -111.71,
    y2: -73.55
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -123.025,-74.516 -121.313,-76.388 -113.427,-76.388 -111.71,-73.55  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -131.954,
    y1: -78.34,
    x2: -125.245,
    y2: -73.823
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -135.807,
    y1: -73.159,
    x2: -131.954,
    y2: -77.689
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -147.342,-79.935 -144.586,-72.097 -140.299,-79.935 -135.807,-74.168  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -151.859,
    y: -78.914,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 2.503,
    height: 3.828
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-151.859-77.842l-4.746-1.302c-1.868,0.182-2.811,1.449-2.68,2.909c0.205,2.286,1.844,3.719,3.828,4.517 c3.624,0.982,7.248,0.887,10.871-0.379"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -151.859,
    y1: -75.086,
    x2: -157.859,
    y2: -73.231
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -144.586,-72.097 -144.586,-69.765 -140.611,-69.765 -140.611,-72.097  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-139.158-72.097v2.538c0,1.825-6.881,1.65-6.881,0v-2.538"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-133.347-40.912c2.789,0,5.064-2.275,5.064-5.064c0-2.79-2.275-5.065-5.064-5.065c-2.789,0-5.064,2.275-5.064,5.065 C-138.411-43.188-136.135-40.912-133.347-40.912z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-139.195-49.928c1.313-1.942,3.504-3.107,5.849-3.107c0.611,0,1.219,0.08,1.81,0.236"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-144.219-68.413l4.991,18.464c-0.661,1.073-1.069,2.225-1.158,3.469l-3.574,5.606c-2.592,4.918,3.221,8.742,6.877,5.856 l4.459-3.939c3.599-0.371,6.334-3.403,6.334-7.02c0-3.266-2.218-6.013-5.26-6.777l-7.872-16.243"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -142.173,-43.678 -136.549,-42.054 -134.853,-36.987  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-139.988-36.113c1.5,0,2.724-1.224,2.724-2.724c0-1.501-1.223-2.725-2.724-2.725s-2.724,1.224-2.724,2.725 C-142.712-37.337-141.489-36.113-139.988-36.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-135.443-32.385c2.35,0.312,3.675,0.74,3.675,1.187c0,0.917-5.482,1.66-12.246,1.66s-12.247-0.743-12.247-1.66 c0-0.446,1.325-0.875,3.675-1.187"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -144.311,-40.079 -149.619,-40.079 -149.619,-33.331  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-135.447-34.221c0-0.257-0.615-0.506-1.75-0.711 M-135.443-34.212v2.762c0,0.643-3.837,1.162-8.571,1.162s-8.571-0.52-8.571-1.162 v-2.762c0,0.642,3.837,1.163,8.571,1.163S-135.443-33.57-135.443-34.212L-135.443-34.212z M-152.586-34.221 c0-0.34,1.083-0.664,2.968-0.888"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -149.619,
    y1: -40.079,
    x2: -143.392,
    y2: -33.052
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-131.769-31.198v7.472c0,0.917-5.482,1.661-12.246,1.661s-12.247-0.744-12.247-1.661v-7.472"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -129.766,
    y1: -49.559,
    x2: -136.549,
    y2: -42.054
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -134.566,-58.98 -141.897,-68.271 -141.246,-57.413 -136.168,-52.577  "
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    cx: -137.986,
    cy: -58.005,
    r: 1.38
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-143.392-33.052c-3.097,0.275-5.234,1.085-6.34,2.468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-152.586-32.385c-1.71,0.521-2.128,1.247-1.071,2.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -156.261,-23.727 -143.35,-29.541 -131.769,-23.727  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-75.939-76.037h50.879c1.948,0,3.542,1.594,3.542,3.543v37.353c0,1.949-1.594,3.542-3.542,3.542h-50.879 c-1.948,0-3.542-1.593-3.542-3.542v-37.353C-79.481-74.443-77.888-76.037-75.939-76.037z"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -79.481,
    y1: -41.903,
    x2: -21.519,
    y2: -41.903
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -70.466,-48.987 -52.754,-65.41 -40.357,-53.656 -29.891,-63.8  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -74.974,
    y1: -76.037,
    x2: -79.481,
    y2: -41.903
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -79.481,-41.903 -51.467,-31.6 -21.519,-41.903  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -73.041,-31.6 -43.738,-41.903 -21.519,-35.142  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -51.467,
    y1: -31.6,
    x2: -51.467,
    y2: -25.963
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -69.098,
    y1: -25.963,
    x2: -33.837,
    y2: -25.963
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-206.711,42.849l0.789-8.449l2.141-9.961c0.645-3-2.598-3.432-3.307-0.968l-2.427,8.436c-0.067,0.274-0.253,0.445-0.512,0.422l0,0 c-0.259-0.023-0.451-0.253-0.428-0.512l1.003-14.441c0.246-3.544-3.926-3.435-4.285-0.378l-1.662,14.161 c-0.047,0.316-0.237,0.525-0.526,0.525l0,0c-0.29,0-0.526-0.236-0.526-0.525V13.804c0-1.322-1.082-2.404-2.403-2.404l0,0 c-1.323,0-2.367,1.082-2.404,2.404l-0.451,16.555c0,0.406-0.333,0.74-0.741,0.74l0,0c-0.408,0-0.741-0.334-0.741-0.74 l-0.758-14.106c-0.073-1.319-1.148-2.258-2.393-2.258l0,0c-1.246,0-2.172,1.22-2.126,2.542l0.665,19.343 c0.038,0.755-0.549,1.401-1.304,1.439l0,0c-0.281,0.014-0.546-0.059-0.771-0.193l-5.043-4.162 c-1.503-0.926-3.072-0.677-3.999,0.213c-0.559,0.572-0.505,1.256,0.038,2.028c1.475,1.656,3.042,3.235,4.425,4.969 c1.2,1.502,2.408,3.026,3.313,4.722c3.1,5.813,6.941,9.816,13.541,9.749C-210.769,54.52-207.139,50.586-206.711,42.849z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -230.392,4.291 -218.5,4.291 -206.608,4.291 -198.2,12.699 -189.791,21.108 -189.791,33 -189.791,44.892 -198.2,53.301  -206.608,61.709 -218.5,61.709 -230.392,61.709 -238.8,53.301 -247.209,44.892 -247.209,33 -247.209,21.108 -238.8,12.699  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -226.343,13.994 -230.392,4.291 -218.854,11.399  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -211.709,14.729 -206.608,4.291 -204.934,21.904  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -227.805,35.879 -247.209,21.108 -239.312,34.184 -247.209,44.892 -227.549,50.217 -230.392,61.709 -217.605,54.644  -206.608,61.709 -189.791,21.108 -204.934,21.904  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -206.608,4.291 -189.791,44.892 -206.711,42.849 -206.608,61.709  "
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-157.162,29.662l8.63-19.655c9.93-8.037,23.491-8.359,31.977,1.76c6.742,8.039,6.062,17.886-0.146,27.724 c-0.95,1.148-1.616,3.313-1.613,4.84l2.786,17.603h-19.069c-1.539-0.167-2.469-0.812-2.64-2.054 c-0.01-2.434-1.165-3.776-3.227-4.254h-6.601c-4.101,0.096-6.363-1.881-6.454-5.134v-5.721h-2.641 c-1.797-0.171-2.53-1.223-2.64-2.22l0.507-3.795L-157.162,29.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-136.383,16.662h25.377c0.442,0,0.806,0.363,0.806,0.807v4.841c0,0.444-0.363,0.806-0.806,0.806h-25.377 c-0.444,0-0.807-0.361-0.807-0.806v-4.841C-137.19,17.025-136.827,16.662-136.383,16.662z"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -137.039,
    y1: 17,
    x2: -110.2,
    y2: 18.202
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    cx: -122.008,
    cy: 20.109,
    r: 1.174
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    cx: -118.414,
    cy: 20.109,
    r: 1.174
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    cx: -114.674,
    cy: 20.109,
    r: 1.174
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -132.061,4.076 -137.039,17 -128.608,23.115 -134.921,61.889  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -115.528,61.933 -153.519,44.771 -152.004,31.623 -157.423,31.763  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -152.004,
    y1: 31.623,
    x2: -158.668,
    y2: 41.569
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -155.968,
    y1: 31.725,
    x2: -158.117,
    y2: 37.341
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -157.359,10.795 -157.162,29.662 -152.004,31.623 -142.47,25.39 -137.039,17 -139.976,15.121 -142.617,14.682 -152.225,8.814  -156.771,8.814  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -152.225,8.814 -157.359,10.795 -142.47,25.39 -142.617,14.682  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-136.845,22.97c-1.036,1.855-3.024,2.52-5.625,2.42l-5.062,30.237"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -138.608,
    y1: 56.481,
    x2: -128.608,
    y2: 23.115
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -153.519,
    y1: 50.491,
    x2: -118.314,
    y2: 44.33
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-73.871,38.789l2.668-9.146c0.102-8.23,3.146-16.347,7.377-19.771c9.988-8.084,23.628-8.408,32.164,1.771 c6.781,8.086,6.098,17.99-0.147,27.886c-0.956,1.154-1.626,3.331-1.623,4.868l2.803,17.705h-19.18 c-1.549-0.167-2.484-0.816-2.656-2.065c-0.009-2.447-1.171-3.799-3.246-4.278h-6.639c-4.125,0.096-6.4-1.893-6.492-5.164V44.84 h-2.656c-1.807-0.173-2.545-1.23-2.655-2.232v-1.918L-73.871,38.789z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-59.206,22.288l-11.997,7.354l21.15,7.015v-2.264c0.034-1.927,1.018-3.617,3.149-5.02l7.283-8.365 c-0.347-5.144-4.231-8.465-9.94-8.465C-55.232,12.544-58.677,16.482-59.206,22.288z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " -59.206,22.288 -65.252,11.25 -49.561,12.544 -31.662,11.643 -39.62,21.009 -33.403,43.8 -62.351,55.758 -68.807,51.131  -50.25,46.105 -30.63,62.102  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M-39.62,21.009c-0.374,4.157-2.972,6.832-7.283,8.365l13.5,14.426"
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -71.203,
    y1: 29.643,
    x2: -46.903,
    y2: 29.374
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -68.843,
    y1: 44.84,
    x2: -73.871,
    y2: 38.789
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -50.264,
    y1: 62.023,
    x2: -50.264,
    y2: 40.692
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: -49.561,
    y1: 12.544,
    x2: -48.081,
    y2: 3.899
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-238.197,108.065 -239.837,108.045 -244.858,101.349 -244.858,107.89 -246.358,107.89  -246.358,98.857 -244.836,98.877 -239.08,106.555 -238.971,106.556 -233.524,98.773 -231.978,98.781 -231.978,107.89  -233.478,107.89 -233.478,101.323  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-221.102,108.228 -229.006,108.228 -229.006,98.375 -221.102,98.375 -221.102,99.875  -227.506,99.875 -227.506,106.728 -221.102,106.728  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -228.256,
    y: 102.654,
    fill: "#FFFFFF",
    width: 7.154,
    height: 1.5
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-206.354,108.207 -207.773,108.18 -215.433,100.433 -215.433,107.89 -216.933,107.89  -216.933,98.31 -215.382,98.351 -207.854,105.964 -207.854,98.588 -206.354,98.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-193.439,108.228 -201.091,108.228 -203.247,106.252 -203.247,98.727 -201.747,98.727  -201.747,105.592 -200.508,106.728 -194.08,106.728 -193.14,105.746 -193.14,98.678 -191.64,98.678 -191.64,106.348  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: -247.174,
    y: 118.409,
    fill: "#FFFFFF",
    width: 56.707,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -247.174,
    y: 128.714,
    fill: "#FFFFFF",
    width: 56.707,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -247.174,
    y: 139.018,
    fill: "#FFFFFF",
    width: 56.707,
    height: 1.5
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-150.259,111.459 -155.322,111.459 -155.322,105.029 -150.259,105.029 -150.259,106.279  -154.072,106.279 -154.072,110.209 -150.259,110.209  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -154.697,
    y: 107.746,
    fill: "#FFFFFF",
    width: 4.438,
    height: 1.25
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-130.382,111.531 -135.955,111.531 -137.561,110.063 -137.561,104.971 -136.311,104.971  -136.311,109.512 -135.47,110.281 -130.915,110.281 -130.287,109.626 -130.287,104.936 -129.037,104.936 -129.037,110.128  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-121.916,111.477 -126.992,111.477 -126.992,105.029 -121.916,105.029 -121.916,106.279  -125.742,106.279 -125.742,110.227 -121.916,110.227  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -126.367,
    y: 107.756,
    fill: "#FFFFFF",
    width: 4.451,
    height: 1.25
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-112.451,111.555 -119.785,111.555 -119.785,109.643 -118.535,109.643 -118.535,110.305  -113.701,110.305 -113.701,108.951 -119.754,108.951 -119.754,105.027 -112.355,105.027 -112.355,106.684 -113.605,106.684  -113.605,106.277 -118.504,106.277 -118.504,107.701 -112.451,107.701  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-163.667,111.506h-1.25v-5.949l0.558-0.592h6.238l0.601,0.524v3.685h-6.147V111.506z M-163.667,107.924 h4.897v-1.709h-4.897V107.924z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-157.442,111.506 -158.692,111.506 -158.692,110.101 -159.719,108.969 -158.793,108.129  -157.442,109.618  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-140.718,111.666h-5.702l-0.973-0.757v-5.277l0.719-0.661h5.943l0.736,0.743v5.166L-140.718,111.666z  M-145.991,110.416l4.746-0.022l-0.007-4.173h-4.89v4.077L-145.991,110.416z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -143.414,
    y: 109.958,
    transform: "matrix(0.8524 0.5228 -0.5228 0.8524 36.9484 90.2503)",
    fill: "#FFFFFF",
    width: 4.001,
    height: 1.251
  })), /*#__PURE__*/React.createElement("rect", {
    x: -108.461,
    y: 105.654,
    fill: "#FFFFFF",
    width: 1.25,
    height: 5.822
  }), /*#__PURE__*/React.createElement("rect", {
    x: -111.016,
    y: 105.029,
    fill: "#FFFFFF",
    width: 6.348,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-137.986,122.886 -139.099,122.317 -135.981,116.204 -134.632,116.146 -131.486,122.317  -132.6,122.886 -135.292,117.604  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -137.475,
    y: 119.881,
    fill: "#FFFFFF",
    width: 4.342,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-146.867,133.416h-6.675v-6.695h6.662l0.736,0.743v5.166L-146.867,133.416z M-152.292,132.166 l4.897-0.022l-0.007-4.173h-4.89V132.166z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-138.414,133.418 -143.477,133.418 -143.477,126.986 -138.414,126.986 -138.414,128.236  -142.227,128.236 -142.227,132.168 -138.414,132.168  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -142.852,
    y: 129.705,
    fill: "#FFFFFF",
    width: 4.438,
    height: 1.25
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-130.342,133.645 -131.591,133.629 -134.947,129.152 -134.947,133.42 -136.197,133.42  -136.197,127.005 -134.981,127.021 -130.974,132.368 -127.18,126.947 -125.947,126.955 -125.947,133.42 -127.197,133.42  -127.197,129.152  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-116.858,133.438h-5.704l-0.973-0.757v-5.277l0.72-0.661h5.943l0.735,0.743v5.166L-116.858,133.438z  M-122.133,132.188l4.746-0.022l-0.007-4.173h-4.892v4.077L-122.133,132.188z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-71.66,102.092 -79.719,102.092 -79.719,100.025 -78.469,100.025 -78.469,100.842 -72.91,100.842  -72.909,99.176 -79.684,99.176 -79.684,94.935 -71.554,94.935 -71.554,96.713 -72.804,96.713 -72.804,96.185 -78.434,96.185  -78.434,97.926 -71.659,97.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-61.037,102.057 -69.256,102.057 -69.256,94.935 -61.126,94.935 -61.126,97.127 -62.376,97.127  -62.376,96.185 -68.006,96.185 -68.006,100.807 -62.287,100.807 -62.287,100.098 -61.037,100.098  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-57.344,102.183h-1.25v-7.248h8.13v4.563h-6.88V102.183z M-57.344,98.247h5.63v-2.063h-5.63V98.247z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-50.377,102.183 -51.627,102.183 -51.627,100.581 -52.796,99.293 -51.87,98.453 -50.377,100.099  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-30.376,102.057 -37.14,102.057 -37.14,94.974 -35.89,94.974 -35.89,100.807 -30.376,100.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-21.893,102.057 -28.657,102.057 -28.657,94.974 -27.407,94.974 -27.407,100.807 -21.893,100.807  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-40.521,102.227h-6.326l-1.039-0.809v-5.839l0.76-0.697h6.591l0.779,0.787v5.721L-40.521,102.227z  M-46.418,100.977h5.346l0.065-0.071v-4.723l-0.051-0.051h-5.579v4.675L-46.418,100.977z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-51.156,144.132c-4.187,0-7.593-3.406-7.593-7.593v-12.101c0-4.187,3.406-7.593,7.593-7.593 s7.593,3.406,7.593,7.593v12.101C-43.563,140.726-46.97,144.132-51.156,144.132z M-51.156,118.346 c-3.359,0-6.093,2.733-6.093,6.093v12.101c0,3.359,2.733,6.093,6.093,6.093s6.093-2.733,6.093-6.093v-12.101 C-45.063,121.079-47.797,118.346-51.156,118.346z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-48.409,114.524 -51.156,111.777 -53.903,114.524 -54.964,113.464 -51.156,109.656  -47.349,113.464  "
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-239.903,184.791 -247.935,184.791 -247.935,182.731 -246.685,182.731 -246.685,183.541  -241.153,183.541 -241.153,181.885 -247.9,181.885 -247.9,177.657 -239.797,177.657 -239.797,179.431 -241.047,179.431  -241.047,178.907 -246.65,178.907 -246.65,180.635 -239.903,180.635  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-229.321,184.755 -237.514,184.755 -237.514,177.657 -229.41,177.657 -229.41,179.843  -230.66,179.843 -230.66,178.907 -236.264,178.907 -236.264,183.505 -230.571,183.505 -230.571,182.803 -229.321,182.803  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-225.643,184.879h-1.25v-7.222h8.104v4.549h-6.854V184.879z M-225.643,180.956h5.604v-2.049h-5.604 V180.956z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-218.702,184.879 -219.952,184.879 -219.952,183.284 -221.116,182.003 -220.19,181.163  -218.702,182.802  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-198.78,184.755 -205.521,184.755 -205.521,177.697 -204.271,177.697 -204.271,183.505  -198.78,183.505  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-190.332,184.755 -197.072,184.755 -197.072,177.697 -195.822,177.697 -195.822,183.505  -190.332,183.505  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-208.888,184.926h-6.302l-1.038-0.809V178.3l0.758-0.696h6.566l0.78,0.784v5.703L-208.888,184.926z  M-214.76,183.676h5.322l0.065-0.071l-0.05-4.751h-5.555v4.652L-214.76,183.676z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-220.078,226.668c-4.172,0-7.566-3.395-7.566-7.566v-12.054c0-4.172,3.394-7.566,7.566-7.566 s7.566,3.395,7.566,7.566v12.054C-212.512,223.273-215.906,226.668-220.078,226.668z M-220.078,200.981 c-3.345,0-6.066,2.722-6.066,6.066v12.054c0,3.345,2.721,6.066,6.066,6.066s6.066-2.722,6.066-6.066v-12.054 C-214.012,203.703-216.733,200.981-220.078,200.981z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-220.078,233.961 -223.873,230.166 -222.813,229.105 -220.078,231.84 -217.344,229.105  -216.283,230.166  "
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-134.599,226.613c-4.102,0-7.438-3.337-7.438-7.439v-12.05c0-4.102,3.336-7.438,7.438-7.438 c4.102,0,7.439,3.337,7.439,7.438v12.05C-127.16,223.276-130.497,226.613-134.599,226.613z M-134.599,200.936 c-3.412,0-6.188,2.776-6.188,6.188v12.05c0,3.413,2.776,6.189,6.188,6.189c3.413,0,6.189-2.776,6.189-6.189v-12.05 C-128.41,203.712-131.187,200.936-134.599,200.936z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-131.778,197.167 -134.599,194.345 -137.42,197.167 -138.304,196.282 -134.599,192.577  -130.894,196.282  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-134.599,233.851 -138.304,230.146 -137.42,229.261 -134.599,232.083 -131.778,229.261  -130.894,230.146  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-154.487,184.724 -162.516,184.724 -162.516,182.664 -161.266,182.664 -161.266,183.474  -155.737,183.474 -155.736,181.819 -162.481,181.819 -162.481,177.592 -154.38,177.592 -154.38,179.364 -155.63,179.364  -155.63,178.842 -161.231,178.842 -161.231,180.569 -154.486,180.569  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-143.909,184.688 -152.099,184.688 -152.099,177.592 -143.997,177.592 -143.997,179.776  -145.247,179.776 -145.247,178.842 -150.849,178.842 -150.849,183.438 -145.159,183.438 -145.159,182.735 -143.909,182.735  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-140.231,184.811h-1.25v-7.219h8.102v4.548h-6.852V184.811z M-140.231,180.89h5.602v-2.048h-5.602 V180.89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-133.293,184.811 -134.543,184.811 -134.543,183.218 -135.707,181.936 -134.781,181.096  -133.293,182.735  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-113.378,184.688 -120.118,184.688 -120.118,177.633 -118.868,177.633 -118.868,183.438  -113.378,183.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-104.933,184.688 -111.671,184.688 -111.671,177.633 -110.421,177.633 -110.421,183.438  -104.933,183.438  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-123.481,184.857h-6.302l-1.036-0.807v-5.817l0.758-0.694h6.565l0.777,0.785v5.7L-123.481,184.857z  M-129.354,183.607h5.321l0.063-0.069l-0.049-4.749h-5.552v4.65L-129.354,183.607z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-42.317,223.716h-11.855c-4.11,0-7.454-3.344-7.454-7.454s3.344-7.454,7.454-7.454h11.855 c4.109,0,7.453,3.344,7.453,7.454S-38.208,223.716-42.317,223.716z M-54.173,210.308c-3.283,0-5.954,2.671-5.954,5.954 s2.671,5.954,5.954,5.954h11.855c3.282,0,5.953-2.671,5.953-5.954s-2.671-5.954-5.953-5.954H-54.173z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-64.106,220.003 -67.848,216.262 -64.106,212.521 -63.046,213.581 -65.727,216.262  -63.046,218.942  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-70.862,194.694 -78.782,194.694 -78.782,192.658 -77.532,192.658 -77.532,193.444  -72.112,193.444 -72.111,191.838 -78.748,191.838 -78.748,187.658 -70.758,187.658 -70.758,189.412 -72.008,189.412  -72.008,188.908 -77.498,188.908 -77.498,190.588 -70.861,190.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-60.455,194.66 -68.532,194.66 -68.532,187.658 -60.542,187.658 -60.542,189.817 -61.792,189.817  -61.792,188.908 -67.282,188.908 -67.282,193.41 -61.705,193.41 -61.705,192.729 -60.455,192.729  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-56.838,194.771h-1.25v-7.112h7.991v4.494h-6.741V194.771z M-56.838,190.902h5.491v-1.994h-5.491 V190.902z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-50.013,194.771 -51.263,194.771 -51.263,193.207 -52.404,191.949 -51.479,191.109  -50.013,192.725  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-30.43,194.66 -37.07,194.66 -37.07,187.708 -35.82,187.708 -35.82,193.41 -30.43,193.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-22.12,194.66 -28.76,194.66 -28.76,187.708 -27.51,187.708 -27.51,193.41 -22.12,193.41  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-40.365,194.826h-6.206l-1.028-0.799v-5.732l0.754-0.688h6.466l0.771,0.778v5.614L-40.365,194.826z  M-46.144,193.576h5.228l0.057-0.062l-0.042-4.658h-5.448v4.56L-46.144,193.576z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-214.88,308.351h-11.855c-4.11,0-7.454-3.344-7.454-7.454s3.344-7.454,7.454-7.454h11.855 c4.11,0,7.454,3.344,7.454,7.454S-210.771,308.351-214.88,308.351z M-226.736,294.942c-3.283,0-5.954,2.671-5.954,5.954 s2.671,5.954,5.954,5.954h11.855c3.283,0,5.954-2.671,5.954-5.954s-2.671-5.954-5.954-5.954H-226.736z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-204.947,304.638 -206.008,303.577 -203.327,300.896 -206.008,298.216 -204.947,297.155  -201.206,300.896  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-239.547,281.515 -247.465,281.515 -247.465,279.479 -246.215,279.479 -246.215,280.265  -240.796,280.265 -240.795,278.658 -247.432,278.658 -247.432,274.479 -239.44,274.479 -239.44,276.232 -240.69,276.232  -240.69,275.729 -246.182,275.729 -246.182,277.408 -239.544,277.408  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-229.138,281.48 -237.216,281.48 -237.216,274.479 -229.226,274.479 -229.226,276.638  -230.476,276.638 -230.476,275.729 -235.966,275.729 -235.966,280.23 -230.388,280.23 -230.388,279.549 -229.138,279.549  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-225.52,281.591h-1.25v-7.112h7.992v4.494h-6.742V281.591z M-225.52,277.723h5.492v-1.994h-5.492 V277.723z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-218.695,281.591 -219.945,281.591 -219.945,280.027 -221.086,278.77 -220.16,277.93  -218.695,279.545  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-199.111,281.48 -205.752,281.48 -205.752,274.528 -204.502,274.528 -204.502,280.23  -199.111,280.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-190.802,281.48 -197.441,281.48 -197.441,274.528 -196.191,274.528 -196.191,280.23  -190.802,280.23  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-209.047,281.646h-6.207l-1.027-0.799v-5.731l0.752-0.69h6.466l0.771,0.777v5.617L-209.047,281.646z  M-214.825,280.396h5.228l0.057-0.063l-0.042-4.658h-5.448v4.561L-214.825,280.396z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-127.224,308.561h-12.005c-4.157,0-7.539-3.382-7.539-7.539s3.382-7.539,7.539-7.539h12.005 c4.156,0,7.538,3.382,7.538,7.539S-123.067,308.561-127.224,308.561z M-139.229,294.982c-3.33,0-6.039,2.709-6.039,6.039 s2.709,6.039,6.039,6.039h12.005c3.329,0,6.038-2.709,6.038-6.039s-2.709-6.039-6.038-6.039H-139.229z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-149.282,304.803 -153.063,301.021 -149.282,297.239 -148.221,298.3 -150.942,301.021  -148.221,303.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-117.171,304.803 -118.231,303.742 -115.511,301.021 -118.231,298.3 -117.171,297.239  -113.39,301.021  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-154.407,281.386 -162.411,281.386 -162.411,279.331 -161.161,279.331 -161.161,280.136  -155.657,280.136 -155.657,278.492 -162.377,278.492 -162.377,274.275 -154.3,274.275 -154.3,276.044 -155.55,276.044  -155.55,275.525 -161.127,275.525 -161.127,277.242 -154.406,277.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-143.867,281.351 -152.032,281.351 -152.032,274.275 -143.956,274.275 -143.956,276.455  -145.206,276.455 -145.206,275.525 -150.782,275.525 -150.782,280.101 -145.117,280.101 -145.117,279.402 -143.867,279.402  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-140.203,281.471h-1.25v-7.195h8.077v4.536h-6.827V281.471z M-140.203,277.562h5.577v-2.036h-5.577 V277.562z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-133.291,281.471 -134.542,281.471 -134.542,279.884 -135.699,278.607 -134.773,277.768  -133.291,279.401  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-113.452,281.351 -120.169,281.351 -120.169,274.318 -118.919,274.318 -118.919,280.101  -113.452,280.101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-105.037,281.351 -111.752,281.351 -111.752,274.318 -110.502,274.318 -110.502,280.101  -105.037,280.101  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-123.517,281.52h-6.28l-1.033-0.807v-5.795l0.757-0.695h6.542l0.775,0.784v5.68L-123.517,281.52z  M-129.367,280.27h5.3l0.062-0.067l-0.047-4.729h-5.527v4.631L-129.367,280.27z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1C75BC",
    d: "M-49.297,317.975c3.647-5.122,7.941-13.33,12.197-21.18 c23.825-43.943-50.456-43.978-23.422,2.688C-56.514,306.404-52.565,313.389-49.297,317.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M-42.488,278.443c0,0.002,0,0.002,0,0.002 c0.906,0.517,1.547,1.444,1.666,2.53v-7.889l-5.472,3.159L-42.488,278.443L-42.488,278.443z M-56.36,284.926c0,0,0,0,0-0.002 c-0.906-0.517-1.546-1.444-1.666-2.528v7.889l5.472-3.159L-56.36,284.926L-56.36,284.926z M-42.512,282.046 c1.007,0.574,1.688,1.655,1.688,2.897v5.341h-0.005l-15.51-8.959c0,0,0,0,0.002-0.002c-1.009-0.574-1.689-1.655-1.689-2.899v-5.341 h0.005l15.51,8.961C-42.512,282.044-42.512,282.044-42.512,282.046z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -248.3145 383.332)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.5,
    strokeMiterlimit: 45,
    fontFamily: "'Roboto-Regular'",
    fontSize: 28.3414,
    letterSpacing: 2
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.215,
    y: 0,
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.5,
    strokeMiterlimit: 45,
    fontFamily: "'Roboto-Regular'",
    fontSize: 28.3414,
    letterSpacing: 2
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.832,
    y: 0,
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.5,
    strokeMiterlimit: 45,
    fontFamily: "'Roboto-Regular'",
    fontSize: 28.3414
  }, "P"))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9677 0 0 1 -162.5923 383.8691)",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.5,
    strokeMiterlimit: 45,
    fontFamily: "'Roboto-Regular'",
    fontSize: 30.181
  }, "C"), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.5,
    strokeMiterlimit: 2.6131,
    points: " -136.939,361.362 -132.83,372.271 -132.747,372.271 -128.641,361.362 -125.229,361.362 -125.229,382.819 -127.896,382.819  -127.896,374.329 -127.624,365.606 -127.693,365.593 -131.912,376.294 -133.686,376.294 -137.873,365.638 -137.942,365.647  -137.688,374.329 -137.688,382.819 -140.355,382.819 -140.355,361.362  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.5,
    strokeMiterlimit: 2.6131,
    d: " M-107.152,374.837c-1.009-1.126-2.869-1.312-4.318-1.496c-2.315-0.291-4.046-1.046-5.316-2.098 c-1.271-1.055-1.908-2.671-1.908-4.264c0-1.676,0.685-3.07,2.058-4.191c1.368-1.122,3.145-1.686,5.328-1.686 c2.351,0,4.215,0.645,5.607,1.937c1.388,1.289,2.06,2.781,2.01,4.482l-0.027,0.092h-2.77c0-1.26-0.419-2.275-1.249-3.055 c-0.83-0.773-2.022-1.162-3.571-1.162c-1.443,0-2.556,0.327-3.326,0.977c-0.767,0.653-1.156,1.503-1.156,2.555 c0,0.931,0.416,1.706,1.253,2.329c2.634,1.967,7.373,1.686,9.371,3.534c2.321,2.147,2.219,6.777-0.499,8.8 c-1.413,1.052-3.263,1.575-5.542,1.575c-2.139,0-4.034-0.584-5.678-1.75c-1.647-1.169-2.445-3.307-2.396-5.25l0.029-0.091h2.768 c0,1.376,0.512,3.006,1.52,3.72c1.012,0.716,2.263,1.077,3.758,1.077c1.463,0,2.627-0.454,3.48-1.066 C-106.241,378.739-105.946,376.178-107.152,374.837z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.5,
    strokeMiterlimit: 2.6131,
    points: " -41.534,376.053 -51.241,376.053 -51.241,385.737 -54.117,385.737 -54.117,364.46 -40.044,364.46 -40.044,366.735 -51.241,366.735  -51.241,373.779 -41.534,373.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.5,
    strokeMiterlimit: 2.6131,
    points: " -72.967,385.275 -69.469,374.029 -69.387,374.029 -65.889,385.275 -62.505,385.275 -61.354,364.431 -64.001,364.431  -64.88,380.923 -68.556,370.037 -70.316,370.037 -73.892,380.894 -74.858,364.431 -77.503,364.431 -76.353,385.275  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.5,
    strokeMiterlimit: 2.6131,
    d: " M-22.813,377.73c-0.998-1.115-2.843-1.301-4.28-1.482c-2.297-0.289-4.013-1.037-5.271-2.081c-1.26-1.045-1.892-2.647-1.892-4.228 c0-1.661,0.679-3.044,2.039-4.155c1.357-1.111,3.118-1.671,5.283-1.671c2.328,0,4.179,0.639,5.56,1.92 c1.377,1.277,2.04,2.758,1.991,4.444l-0.025,0.09h-2.748c0-1.248-0.413-2.254-1.236-3.028c-0.824-0.767-2.007-1.152-3.541-1.152 c-1.432,0-2.535,0.325-3.298,0.969c-0.763,0.647-1.146,1.49-1.146,2.533c0,0.923,0.413,1.691,1.242,2.31 c2.609,1.95,7.311,1.671,9.29,3.504c2.301,2.13,2.202,6.72-0.493,8.725c-1.4,1.043-3.237,1.562-5.495,1.562 c-2.12,0-4-0.579-5.632-1.735c-1.631-1.158-2.424-3.278-2.373-5.204l0.029-0.09h2.743c0,1.363,0.507,2.979,1.506,3.688 c1.004,0.71,2.244,1.068,3.727,1.068c1.45,0,2.604-0.45,3.449-1.057C-21.908,381.6-21.618,379.061-22.813,377.73z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1C75BC",
    points: "-219.453,463.373 -219.453,456.787 -225.993,456.787  -225.993,455.756 -219.453,455.756 -219.453,448.854 -218.312,448.854 -218.312,455.756 -211.549,455.756 -211.549,456.787  -218.312,456.787 -218.312,463.373  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1C75BC",
    d: "M-218.796,428.625c-15.138,0-27.488,12.346-27.488,27.488 s12.351,27.488,27.488,27.488c15.142,0,27.491-12.346,27.491-27.488S-203.654,428.625-218.796,428.625z M-218.796,482.52 c-14.544,0-26.406-11.857-26.406-26.406s11.862-26.406,26.406-26.406c14.548,0,26.404,11.857,26.404,26.406 S-204.248,482.52-218.796,482.52z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M-59.978,453.814c0.229,0.17,0.914,0.656,2.086,1.457c1.17,0.828,2.055,1.428,2.684,1.885 c0.057,0.029,0.199,0.143,0.428,0.314c0.229,0.143,0.4,0.285,0.572,0.371c0.143,0.115,0.314,0.229,0.514,0.344 c0.199,0.113,0.4,0.199,0.6,0.285c0.172,0.057,0.342,0.086,0.514,0.086l0,0c0.172,0,0.344-0.029,0.514-0.086 c0.201-0.086,0.4-0.172,0.6-0.285c0.201-0.115,0.373-0.229,0.543-0.344c0.143-0.086,0.314-0.229,0.543-0.371 c0.229-0.172,0.371-0.285,0.428-0.314c0.629-0.457,2.229-1.543,4.799-3.342c0.484-0.344,0.914-0.771,1.256-1.258 c0.314-0.486,0.486-1,0.486-1.543c0-0.457-0.172-0.828-0.486-1.143c-0.314-0.344-0.713-0.486-1.143-0.486H-60.12 c-0.514,0-0.914,0.172-1.199,0.514c-0.285,0.373-0.428,0.801-0.428,1.344c0,0.428,0.199,0.885,0.57,1.4 C-60.806,453.127-60.405,453.527-59.978,453.814L-59.978,453.814z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M-44.442,454.928c-2.227,1.516-3.939,2.686-5.082,3.516c-0.4,0.285-0.715,0.514-0.943,0.686 c-0.256,0.143-0.57,0.314-0.971,0.484c-0.4,0.172-0.771,0.258-1.143,0.258l0,0c-0.371,0-0.742-0.086-1.143-0.258 c-0.398-0.17-0.713-0.342-0.971-0.484c-0.229-0.172-0.543-0.4-0.941-0.686c-0.914-0.658-2.6-1.857-5.084-3.516 c-0.371-0.258-0.742-0.572-1.027-0.914v8.143c0,0.457,0.17,0.828,0.484,1.143c0.314,0.344,0.715,0.486,1.143,0.486h15.078 c0.457,0,0.828-0.143,1.143-0.486c0.314-0.314,0.486-0.686,0.486-1.143v-8.143C-43.7,454.355-44.042,454.643-44.442,454.928 L-44.442,454.928z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BC",
    points: "-67.374,455.098 -69.899,455.098 -69.899,452.57 -71.176,452.57 -71.176,455.098 -73.701,455.098  -73.701,456.371 -71.176,456.371 -71.176,458.898 -69.899,458.898 -69.899,456.371 -67.374,456.371  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M-81.276,457.622h3.58c-0.541,1.472-1.938,2.552-3.58,2.552c-2.108,0-3.801-1.717-3.801-3.803 c0-2.109,1.692-3.801,3.801-3.801c0.906,0,1.766,0.318,2.453,0.906l1.666-1.912c-1.152-0.982-2.6-1.521-4.119-1.521 c-3.505,0-6.325,2.82-6.325,6.328c0,3.484,2.82,6.33,6.325,6.33c3.482,0,6.326-2.846,6.326-6.33v-1.273h-6.326V457.622z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M-94.126,458.184v6.057h-3.512v-5.658c0-1.398-0.514-2.371-1.771-2.371c-0.971,0-1.542,0.658-1.799,1.287 c-0.086,0.229-0.114,0.543-0.114,0.855v5.887h-3.513c0,0,0.058-9.572,0-10.543h3.513v1.486l-0.029,0.027h0.029v-0.027 c0.457-0.715,1.285-1.744,3.17-1.744C-95.867,453.439-94.126,454.953-94.126,458.184L-94.126,458.184z M-108.489,448.611 c-1.199,0-1.999,0.771-1.999,1.801c0,1.027,0.771,1.828,1.942,1.828h0.027c1.229,0,1.971-0.801,1.971-1.828 C-106.576,449.383-107.29,448.611-108.489,448.611L-108.489,448.611z M-110.288,464.24h3.512v-10.543h-3.512V464.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M-119.184,451.125c-0.6,0.258-1.257,0.457-1.913,0.543c0.686-0.428,1.199-1.086,1.456-1.857 c-0.628,0.4-1.342,0.658-2.112,0.801c-0.601-0.629-1.457-1.029-2.428-1.029c-1.828,0-3.313,1.486-3.313,3.314 c0,0.258,0.027,0.516,0.085,0.744c-2.771-0.115-5.197-1.457-6.855-3.457c-0.286,0.484-0.428,1.057-0.428,1.656 c0,1.172,0.571,2.172,1.458,2.771c-0.544,0-1.059-0.172-1.487-0.4v0.029c0,1.6,1.143,2.943,2.657,3.258 c-0.285,0.084-0.57,0.113-0.885,0.113c-0.199,0-0.4-0.029-0.629-0.057c0.43,1.314,1.658,2.285,3.114,2.314 c-1.143,0.885-2.57,1.428-4.113,1.428c-0.286,0-0.543-0.027-0.8-0.057c1.457,0.943,3.2,1.486,5.085,1.486 c6.111,0,9.452-5.059,9.452-9.459v-0.428C-120.212,452.383-119.641,451.811-119.184,451.125L-119.184,451.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M-155.107,450.824v2.287h-1.685v2.799h1.685v8.314h3.427v-8.314h2.313c0,0,0.229-1.342,0.343-2.799h-2.627 v-1.914c0-0.287,0.372-0.686,0.743-0.686h1.885v-2.916h-2.57C-155.193,447.596-155.107,450.396-155.107,450.824L-155.107,450.824z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    stroke: "#221F20",
    strokeWidth: 0.1143,
    strokeMiterlimit: 10,
    d: "M22.208,570.385 c0,0.533-0.106,1.067-0.212,1.602c-0.11,0.431-0.322,0.855-0.644,1.177c-0.212,0.432-0.535,0.644-0.963,0.855 c-0.427,0.22-0.961,0.22-1.494,0.22c-0.212,0-0.322,0-0.428,0c-0.216,0-0.322,0-0.428-0.11v-0.854h0.105 c0.106,0.102,0.215,0.102,0.322,0.211c0.216,0,0.317,0,0.533,0c0.64,0,1.178-0.211,1.604-0.643 c0.425-0.322,0.641-0.959,0.641-1.603c-0.216,0.11-0.534,0.322-0.749,0.322c-0.318,0.103-0.534,0.103-0.856,0.103 c-0.317,0-0.533,0-0.745-0.103c-0.212,0-0.428-0.109-0.644-0.212c-0.322-0.22-0.535-0.432-0.641-0.754 c-0.105-0.321-0.215-0.643-0.215-1.066c0-0.644,0.215-1.178,0.644-1.712c0.533-0.432,1.067-0.644,1.711-0.644 c0.321,0,0.639,0.11,0.961,0.212c0.216,0.11,0.534,0.22,0.641,0.432c0.321,0.212,0.533,0.534,0.644,0.958 C22.102,569.207,22.208,569.741,22.208,570.385L22.208,570.385z M21.246,570.173c0-0.542,0-0.856-0.105-1.178 c-0.11-0.22-0.213-0.534-0.429-0.644c-0.106-0.109-0.215-0.213-0.428-0.322c-0.212,0-0.321-0.109-0.533-0.109 c-0.428,0-0.75,0.219-1.067,0.432c-0.216,0.321-0.323,0.644-0.323,1.178c0,0.321,0,0.533,0.107,0.745 c0.105,0.11,0.216,0.321,0.428,0.432c0.105,0.103,0.212,0.103,0.428,0.212c0.105,0,0.317,0,0.533,0s0.533,0,0.749-0.109 c0.212,0,0.425-0.103,0.641-0.213c0-0.102,0-0.102,0-0.211C21.246,570.274,21.246,570.274,21.246,570.173L21.246,570.173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    stroke: "#221F20",
    strokeWidth: 0.1143,
    strokeMiterlimit: 10,
    d: "M27.77,570.706 c0,1.28-0.107,2.136-0.535,2.669c-0.321,0.644-0.961,0.863-1.816,0.863c-0.749,0-1.39-0.22-1.712-0.863 c-0.428-0.533-0.644-1.389-0.644-2.669c0-1.177,0.216-2.033,0.644-2.677c0.322-0.533,0.963-0.855,1.712-0.855 c0.855,0,1.495,0.322,1.816,0.965C27.662,568.673,27.77,569.529,27.77,570.706L27.77,570.706z M26.595,572.842 c0.104-0.322,0.212-0.534,0.212-0.855c0.106-0.425,0.106-0.747,0.106-1.28c0-0.432,0-0.855-0.106-1.177 c0-0.322-0.108-0.644-0.212-0.856c-0.109-0.212-0.216-0.431-0.432-0.534c-0.212-0.109-0.423-0.219-0.745-0.219 c-0.216,0-0.432,0.109-0.644,0.219c-0.213,0.104-0.321,0.322-0.428,0.534c-0.105,0.213-0.216,0.534-0.216,0.856 c-0.103,0.424-0.103,0.745-0.103,1.177c0,0.533,0,0.958,0.103,1.28c0,0.321,0.11,0.533,0.216,0.855 c0.106,0.219,0.215,0.321,0.428,0.533c0.11,0.109,0.428,0.109,0.644,0.109c0.322,0,0.533,0,0.745-0.109 C26.379,573.273,26.485,573.061,26.595,572.842L26.595,572.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    stroke: "#221F20",
    strokeWidth: 0.1143,
    strokeMiterlimit: 10,
    d: "M33.436,570.706 c0,1.28-0.216,2.136-0.644,2.669c-0.317,0.644-0.961,0.863-1.711,0.863c-0.852,0-1.386-0.22-1.817-0.863 c-0.321-0.533-0.533-1.389-0.533-2.669c0-1.177,0.212-2.033,0.533-2.677c0.432-0.533,0.966-0.855,1.817-0.855 c0.75,0,1.394,0.322,1.821,0.965C33.22,568.673,33.436,569.529,33.436,570.706L33.436,570.706z M32.259,572.842 c0.105-0.322,0.105-0.534,0.216-0.855c0-0.425,0-0.747,0-1.28c0-0.432,0-0.855,0-1.177c-0.11-0.322-0.11-0.644-0.216-0.856 c-0.106-0.212-0.322-0.431-0.534-0.534c-0.105-0.109-0.321-0.219-0.644-0.219c-0.318,0-0.533,0.109-0.746,0.219 c-0.216,0.104-0.321,0.322-0.428,0.534c-0.108,0.213-0.212,0.534-0.212,0.856c0,0.424,0,0.745,0,1.177c0,0.533,0,0.958,0,1.28 c0,0.321,0.104,0.533,0.212,0.855c0.106,0.219,0.212,0.321,0.428,0.533c0.213,0.109,0.428,0.109,0.746,0.109 c0.322,0,0.538,0,0.75-0.109C31.937,573.273,32.152,573.061,32.259,572.842L32.259,572.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    stroke: "#221F20",
    strokeWidth: 0.1143,
    strokeMiterlimit: 10,
    d: "M38.354,574.128H34.72v-0.644h1.389v-4.599 H34.72v-0.644c0.212,0,0.317,0,0.64,0c0.216,0,0.321-0.104,0.427-0.104c0.106-0.109,0.216-0.219,0.322-0.321 c0.105-0.108,0.105-0.321,0.212-0.533h0.644v6.2h1.39V574.128z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    stroke: "#221F20",
    strokeWidth: 0.1143,
    strokeMiterlimit: 10,
    d: "M-60.928,573.997H-65.4v-0.939 c0.313-0.313,0.623-0.52,0.936-0.832c0.313-0.313,0.627-0.52,0.936-0.833c0.52-0.52,0.936-0.939,1.146-1.252 c0.205-0.313,0.313-0.727,0.313-1.039c0-0.413-0.107-0.626-0.313-0.833c-0.313-0.206-0.627-0.313-0.936-0.313 c-0.314,0-0.627,0.106-0.936,0.206c-0.314,0-0.627,0.214-0.939,0.42l0,0v-0.939c0.209-0.1,0.521-0.206,0.832-0.313 c0.313-0.1,0.729-0.1,1.043-0.1c0.623,0,1.141,0.1,1.559,0.52c0.416,0.313,0.625,0.726,0.625,1.244 c0,0.313-0.104,0.527-0.104,0.733c-0.105,0.206-0.209,0.413-0.313,0.626c-0.104,0.207-0.209,0.413-0.416,0.52 c-0.104,0.207-0.313,0.413-0.52,0.627c-0.313,0.306-0.729,0.619-1.043,0.932c-0.309,0.206-0.623,0.52-0.936,0.732h3.537V573.997z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#221F20",
    stroke: "#221F20",
    strokeWidth: 0.1143,
    strokeMiterlimit: 10,
    points: "-56.246,568.376 -59.16,573.997  -60.199,573.997 -56.971,568.162 -60.719,568.162 -60.719,567.33 -56.246,567.33  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    stroke: "#221F20",
    strokeWidth: 0.1143,
    strokeMiterlimit: 10,
    d: "M-50.521,570.667 c0,1.139-0.209,2.078-0.523,2.597c-0.416,0.52-0.936,0.833-1.768,0.833s-1.352-0.313-1.768-0.833 c-0.314-0.626-0.52-1.458-0.52-2.597c0-1.146,0.205-2.085,0.52-2.604c0.416-0.52,0.936-0.832,1.768-0.832s1.352,0.313,1.768,0.832 C-50.73,568.688-50.521,569.521-50.521,570.667L-50.521,570.667z M-51.666,572.638c0.102-0.206,0.102-0.519,0.205-0.832 c0-0.306,0-0.726,0-1.139c0-0.42,0-0.84,0-1.146c-0.104-0.42-0.104-0.627-0.205-0.833c-0.104-0.313-0.314-0.42-0.416-0.526 c-0.211-0.206-0.418-0.206-0.73-0.206c-0.309,0-0.52,0-0.727,0.206c-0.105,0.106-0.313,0.214-0.416,0.526 c-0.105,0.206-0.105,0.413-0.209,0.833c0,0.306,0,0.726,0,1.146c0,0.413,0,0.833,0,1.139c0,0.313,0.104,0.626,0.209,0.832 c0.104,0.214,0.207,0.42,0.416,0.526c0.207,0.1,0.418,0.207,0.727,0.207c0.313,0,0.52-0.107,0.73-0.207 C-51.98,573.058-51.77,572.852-51.666,572.638L-51.666,572.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    stroke: "#221F20",
    strokeWidth: 0.1143,
    strokeMiterlimit: 10,
    d: "M-44.801,570.667 c0,1.139-0.205,2.078-0.52,2.597c-0.416,0.52-1.037,0.833-1.768,0.833c-0.832,0-1.352-0.313-1.768-0.833 c-0.314-0.626-0.523-1.458-0.523-2.597c0-1.146,0.209-2.085,0.523-2.604c0.416-0.52,0.936-0.832,1.768-0.832 s1.352,0.313,1.768,0.832C-45.006,568.688-44.801,569.521-44.801,570.667L-44.801,570.667z M-45.941,572.638 c0.104-0.206,0.104-0.519,0.205-0.832c0-0.306,0-0.726,0-1.139c0-0.42,0-0.84,0-1.146c-0.102-0.42-0.102-0.627-0.205-0.833 c-0.107-0.313-0.314-0.42-0.416-0.526c-0.211-0.206-0.418-0.206-0.73-0.206s-0.52,0-0.729,0.206 c-0.104,0.106-0.314,0.214-0.416,0.526c-0.104,0.206-0.104,0.413-0.207,0.833c0,0.306,0,0.726,0,1.146c0,0.413,0,0.833,0,1.139 c0,0.313,0.104,0.626,0.207,0.832c0.102,0.214,0.209,0.42,0.416,0.526c0.209,0.1,0.416,0.207,0.729,0.207s0.52-0.107,0.73-0.207 C-46.256,573.058-46.049,572.852-45.941,572.638L-45.941,572.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    stroke: "#221F20",
    strokeWidth: 0.1143,
    strokeMiterlimit: 10,
    d: "M-39.701,573.997h-3.641v-0.733h1.455 v-4.369h-1.455v-0.626c0.207,0,0.416,0,0.623-0.106c0.211,0,0.416,0,0.52-0.1c0.107-0.106,0.211-0.206,0.313-0.313 c0.104-0.107,0.104-0.207,0.104-0.42h0.73v5.934h1.352V573.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-46.049,541.83c0-3.124,0.936-5.519,2.914-7.287c1.871-1.768,4.369-2.707,7.699-2.707 c3.434,0,5.828,0.939,7.803,2.707c1.875,1.769,2.811,4.163,2.811,7.287c0,3.021-0.936,5.519-2.811,7.287 c-1.975,1.661-4.369,2.601-7.803,2.601c-3.33,0-5.828-0.939-7.699-2.704C-45.113,547.349-46.049,544.851-46.049,541.83 L-46.049,541.83z M-35.748,536.625c-1.143,0-1.975,0.52-2.498,1.665c-0.936,2.185-0.936,4.789,0,7.08 c0.523,1.039,1.355,1.665,2.395,1.665c1.145,0,1.979-0.626,2.498-1.665c0.936-2.291,0.936-4.789,0-7.08 C-33.873,537.145-34.707,536.625-35.748,536.625L-35.748,536.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-64.568,544.225h2.705c2.6,3.224,8.428,3.434,8.844,2.601c0.52-1.142-1.248-1.562-3.432-2.188 c-0.73-0.206-1.354-0.309-1.77-0.52c-1.248-0.313-2.291-0.726-3.018-0.936c-0.729-0.309-1.248-0.622-1.561-0.832 c-0.73-0.52-1.354-1.143-1.666-1.875c-0.313-0.623-0.52-1.455-0.52-2.288c0-1.875,0.73-3.434,2.082-4.579s3.223-1.771,5.514-1.771 c1.143,0,2.186,0.206,3.225,0.416c1.043,0.21,1.979,0.523,2.914,1.043l0.52-0.939h2.707v6.454h-3.123 c-1.975-1.665-7.49-4.163-8.014-1.979c-0.309,0.833,1.563,1.665,3.645,2.085c0.52,0.104,0.313,0,0.621,0.104 c2.813,0.622,4.893,1.455,6.039,2.497c1.143,0.937,1.768,2.288,1.768,3.957c0,1.875-0.729,3.433-2.184,4.579 c-1.459,1.039-3.33,1.665-5.725,1.665c-1.146,0-2.186-0.107-3.225-0.413c-1.043-0.213-2.082-0.626-3.018-1.146l-0.729,1.039h-2.602 V544.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-66.547,532.462v3.644h-0.936c-0.621,0-1.145,0.104-1.248,0.206c-0.207,0.206-0.313,0.626-0.313,1.353 v8.539c0,0.726,0.105,1.245,0.313,1.352c0.209,0.206,0.627,0.313,1.248,0.313h0.936v3.225h-11.131v-3.225h0.936 c0.625,0,1.041-0.106,1.248-0.313c0.209-0.106,0.313-0.626,0.313-1.352v-8.539c0-0.727-0.104-1.146-0.313-1.353 c-0.104-0.103-0.623-0.206-1.248-0.206h-0.936v-3.644H-66.547z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-52.709,563.793c-12.162,0-22.059-9.898-22.059-22.066c0-12.172,9.896-22.073,22.059-22.073 c12.164,0,22.063,9.901,22.063,22.073C-30.646,553.895-40.545,563.793-52.709,563.793z M-52.709,520.906 c-11.475,0-20.807,9.339-20.807,20.82c0,11.479,9.332,20.814,20.807,20.814s20.811-9.336,20.811-20.814 C-31.898,530.245-41.234,520.906-52.709,520.906z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-46.672,561.814c-0.313-0.206-0.625-0.313-0.832-0.52l-0.729,1.146c0.313,0.1,0.625,0.313,0.936,0.52 L-46.672,561.814z M-48.232,562.441L-48.232,562.441l0.416-0.627L-48.232,562.441z M-47.504,561.295 c-1.352-0.832-2.703-1.771-5.205-1.771v1.352c2.188,0,3.33,0.733,4.477,1.566L-47.504,561.295z M-52.709,559.523 c-2.807,0-4.473,1.046-5.928,1.979l0.623,1.039c1.352-0.833,2.811-1.666,5.305-1.666V559.523z M-58.637,561.502L-58.637,561.502 l0.309,0.52L-58.637,561.502z M-58.637,561.502l-0.523,0.206l0.73,1.146l0.416-0.313L-58.637,561.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-46.672,521.738c-0.313,0.207-0.625,0.416-0.832,0.52l-0.729-1.039c0.313-0.206,0.625-0.416,0.936-0.52 L-46.672,521.738z M-47.504,522.258L-47.504,522.258l-0.313-0.52L-47.504,522.258z M-47.504,522.258 c-1.352,0.939-2.703,1.771-5.205,1.771v-1.252c2.188,0,3.33-0.832,4.477-1.559L-47.504,522.258z M-52.709,524.029 c-2.807,0-4.473-0.939-5.928-1.875l0.623-1.142c1.352,0.833,2.811,1.765,5.305,1.765V524.029z M-58.014,521.013L-58.014,521.013 l-0.314,0.52L-58.014,521.013z M-58.637,522.154l-0.523-0.309l0.73-1.043l0.416,0.21L-58.637,522.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-57.125,561.758c-7.809-3.525-12.854-11.389-12.854-20.031c0-8.482,4.959-16.303,12.633-19.928 l0.535,1.131c-7.242,3.42-11.916,10.795-11.916,18.797c0,8.155,4.754,15.569,12.115,18.893L-57.125,561.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-53.852,560.797c-6.906-3.999-11.029-11.129-11.029-19.07c0-7.777,4.145-15.043,10.816-18.964l0.633,1.075 c-6.291,3.7-10.197,10.553-10.197,17.889c0,7.493,3.889,14.218,10.404,17.989L-53.852,560.797z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-47.873,561.758l-0.514-1.139c7.361-3.323,12.119-10.741,12.119-18.893c0-7.998-4.68-15.377-11.92-18.797 l0.533-1.131c7.676,3.625,12.639,11.445,12.639,19.928C-35.016,550.369-40.064,558.232-47.873,561.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-51.146,560.797l-0.627-1.081c6.518-3.775,10.406-10.499,10.406-17.989 c0-7.333-3.906-14.188-10.199-17.889l0.633-1.075c6.672,3.921,10.82,11.19,10.82,18.964 C-40.113,549.668-44.242,556.798-51.146,560.797z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-39.492,525.278c-1.561,1.143-3.227,2.188-5.309,3.12l-0.416-1.245c1.875-0.832,3.537-1.875,5.1-2.917 L-39.492,525.278z M-44.801,528.398c-2.08,0.833-4.471,1.355-7.699,1.355v-1.248c3.018,0,5.309-0.52,7.283-1.353L-44.801,528.398z  M-52.5,529.754c-3.119,0-5.721-0.522-8.012-1.355l0.416-1.142c2.186,0.729,4.58,1.249,7.596,1.249V529.754z M-60.512,528.398 c-2.184-0.726-4.057-1.871-5.824-2.91l0.623-1.146c1.664,1.039,3.535,2.078,5.617,2.914L-60.512,528.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-39.492,558.064c-1.561-1.139-3.227-2.185-5.309-3.116l-0.416,1.245c1.875,0.832,3.537,1.871,5.1,2.918 L-39.492,558.064z M-44.801,554.948c-2.08-0.833-4.471-1.359-7.699-1.359v1.253c3.018,0,5.309,0.52,7.283,1.352L-44.801,554.948z  M-52.5,553.589c-3.119,0-5.721,0.526-8.012,1.359l0.416,1.146c2.186-0.732,4.58-1.252,7.596-1.252V553.589z M-60.512,554.948 c-2.184,0.726-4.057,1.871-5.824,2.91l0.623,1.039c1.664-0.933,3.535-1.972,5.617-2.804L-60.512,554.948z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M33.076,542.08c0-3.124,0.936-5.519,2.914-7.287c1.871-1.768,4.369-2.707,7.699-2.707 c3.434,0,5.828,0.939,7.803,2.707c1.875,1.769,2.811,4.163,2.811,7.287c0,3.021-0.936,5.519-2.811,7.287 c-1.975,1.661-4.369,2.601-7.803,2.601c-3.33,0-5.828-0.939-7.699-2.704C34.012,547.599,33.076,545.101,33.076,542.08L33.076,542.08 z M43.377,536.875c-1.143,0-1.975,0.52-2.498,1.665c-0.936,2.185-0.936,4.789,0,7.08c0.523,1.039,1.355,1.665,2.395,1.665 c1.145,0,1.979-0.626,2.498-1.665c0.936-2.291,0.936-4.789,0-7.08C45.252,537.395,44.418,536.875,43.377,536.875L43.377,536.875z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M14.557,544.475h2.705c2.6,3.224,8.428,3.434,8.844,2.601c0.52-1.142-1.248-1.562-3.432-2.188 c-0.73-0.206-1.354-0.309-1.77-0.52c-1.248-0.313-2.291-0.726-3.018-0.936c-0.729-0.309-1.248-0.622-1.561-0.832 c-0.73-0.52-1.354-1.143-1.666-1.875c-0.313-0.623-0.52-1.455-0.52-2.288c0-1.875,0.73-3.434,2.082-4.579s3.223-1.771,5.514-1.771 c1.143,0,2.186,0.206,3.225,0.416c1.043,0.21,1.979,0.523,2.914,1.043l0.52-0.939h2.707v6.454h-3.123 c-1.975-1.665-7.49-4.163-8.014-1.979c-0.309,0.833,1.563,1.665,3.645,2.085c0.52,0.104,0.313,0,0.621,0.104 c2.813,0.622,4.893,1.455,6.039,2.497c1.143,0.937,1.768,2.288,1.768,3.957c0,1.875-0.729,3.433-2.184,4.579 c-1.459,1.039-3.33,1.665-5.725,1.665c-1.146,0-2.186-0.107-3.225-0.413c-1.043-0.213-2.082-0.626-3.018-1.146l-0.729,1.039h-2.602 V544.475z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M12.578,532.712v3.644h-0.936c-0.621,0-1.145,0.104-1.248,0.206c-0.207,0.206-0.313,0.626-0.313,1.353v8.539 c0,0.726,0.105,1.245,0.313,1.352c0.209,0.206,0.627,0.313,1.248,0.313h0.936v3.225H1.447v-3.225h0.936 c0.625,0,1.041-0.106,1.248-0.313c0.209-0.106,0.313-0.626,0.313-1.352v-8.539c0-0.727-0.104-1.146-0.313-1.353 c-0.104-0.103-0.623-0.206-1.248-0.206H1.447v-3.644H12.578z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M26.416,564.043c-12.162,0-22.059-9.898-22.059-22.066c0-12.172,9.896-22.073,22.059-22.073 c12.164,0,22.063,9.901,22.063,22.073C48.479,554.145,38.58,564.043,26.416,564.043z M26.416,521.156 c-11.475,0-20.807,9.339-20.807,20.82c0,11.479,9.332,20.814,20.807,20.814s20.811-9.336,20.811-20.814 C47.227,530.495,37.891,521.156,26.416,521.156z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M32.453,562.064c-0.313-0.206-0.625-0.313-0.832-0.52l-0.729,1.146c0.313,0.1,0.625,0.313,0.936,0.52 L32.453,562.064z M30.893,562.691L30.893,562.691l0.416-0.627L30.893,562.691z M31.621,561.545 c-1.352-0.832-2.703-1.771-5.205-1.771v1.352c2.188,0,3.33,0.733,4.477,1.566L31.621,561.545z M26.416,559.773 c-2.807,0-4.473,1.046-5.928,1.979l0.623,1.039c1.352-0.833,2.811-1.666,5.305-1.666V559.773z M20.488,561.752L20.488,561.752 l0.309,0.52L20.488,561.752z M20.488,561.752l-0.523,0.206l0.73,1.146l0.416-0.313L20.488,561.752z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M32.453,521.988c-0.313,0.207-0.625,0.416-0.832,0.52l-0.729-1.039c0.313-0.206,0.625-0.416,0.936-0.52 L32.453,521.988z M31.621,522.508L31.621,522.508l-0.313-0.52L31.621,522.508z M31.621,522.508 c-1.352,0.939-2.703,1.771-5.205,1.771v-1.252c2.188,0,3.33-0.832,4.477-1.559L31.621,522.508z M26.416,524.279 c-2.807,0-4.473-0.939-5.928-1.875l0.623-1.142c1.352,0.833,2.811,1.765,5.305,1.765V524.279z M21.111,521.263L21.111,521.263 l-0.314,0.52L21.111,521.263z M20.488,522.404l-0.523-0.309l0.73-1.043l0.416,0.21L20.488,522.404z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M22,562.008c-7.809-3.525-12.854-11.389-12.854-20.031c0-8.482,4.959-16.303,12.633-19.928l0.535,1.131 c-7.242,3.42-11.916,10.795-11.916,18.797c0,8.155,4.754,15.569,12.115,18.893L22,562.008z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M25.273,561.047c-6.906-3.999-11.029-11.129-11.029-19.07c0-7.777,4.145-15.043,10.816-18.964l0.633,1.075 c-6.291,3.7-10.197,10.553-10.197,17.889c0,7.493,3.889,14.218,10.404,17.989L25.273,561.047z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M31.252,562.008l-0.514-1.139c7.361-3.323,12.119-10.741,12.119-18.893c0-7.998-4.68-15.377-11.92-18.797 l0.533-1.131c7.676,3.625,12.639,11.445,12.639,19.928C44.109,550.619,39.061,558.482,31.252,562.008z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M27.979,561.047l-0.627-1.081c6.518-3.775,10.406-10.499,10.406-17.989c0-7.333-3.906-14.188-10.199-17.889 l0.633-1.075c6.672,3.921,10.82,11.19,10.82,18.964C39.012,549.918,34.883,557.048,27.979,561.047z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M39.633,525.528c-1.561,1.143-3.227,2.188-5.309,3.12l-0.416-1.245c1.875-0.832,3.537-1.875,5.1-2.917 L39.633,525.528z M34.324,528.648c-2.08,0.833-4.471,1.355-7.699,1.355v-1.248c3.018,0,5.309-0.52,7.283-1.353L34.324,528.648z  M26.625,530.004c-3.119,0-5.721-0.522-8.012-1.355l0.416-1.142c2.186,0.729,4.58,1.249,7.596,1.249V530.004z M18.613,528.648 c-2.184-0.726-4.057-1.871-5.824-2.91l0.623-1.146c1.664,1.039,3.535,2.078,5.617,2.914L18.613,528.648z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M39.633,558.314c-1.561-1.139-3.227-2.185-5.309-3.116l-0.416,1.245c1.875,0.832,3.537,1.871,5.1,2.918 L39.633,558.314z M34.324,555.198c-2.08-0.833-4.471-1.359-7.699-1.359v1.253c3.018,0,5.309,0.52,7.283,1.352L34.324,555.198z  M26.625,553.839c-3.119,0-5.721,0.526-8.012,1.359l0.416,1.146c2.186-0.732,4.58-1.252,7.596-1.252V553.839z M18.613,555.198 c-2.184,0.726-4.057,1.871-5.824,2.91l0.623,1.039c1.664-0.933,3.535-1.972,5.617-2.804L18.613,555.198z"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -164.873,
    y: 478,
    opacity: 0.55,
    fill: "#1C75BC",
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -139.872,
    y: 478,
    opacity: 0.55,
    fill: "#00A79D",
    width: 24.999,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -114.872,
    y: 478,
    opacity: 0.55,
    fill: "#FBB040",
    width: 24.999,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -89.873,
    y: 478,
    opacity: 0.55,
    fill: "#EF4136",
    width: 24.999,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -64.872,
    y: 478,
    opacity: 0.55,
    fill: "#662D91",
    width: 24.999,
    height: 25
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-107.284,536.049c1.436,0,2.533,1.098,2.533,2.537c0,1.352-1.098,2.536-2.533,2.536 c-1.353,0-2.534-1.185-2.534-2.536C-109.818,537.146-108.637,536.049-107.284,536.049L-107.284,536.049z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-107.623,531.063c-13.264-12.089-29.316-1.186-38.524,8.537 C-134.067,530.895-122.239,525.062-107.623,531.063L-107.623,531.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-151.385,558.786c5.576,18.598,29.822,4.819,39.454-4.056 C-125.281,561.999-141.923,570.875-151.385,558.786L-151.385,558.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-143.445,546.276c0.254-2.872-1.436-4.648-4.899-4.648c-3.126,0-6.083,2.282-6.674,6.001 c-0.676,3.721,1.183,6.003,4.985,6.003c2.957,0,5.406-1.773,6.252-4.732h-3.633c-0.338,1.099-1.014,1.942-2.197,1.942 c-1.943,0-2.028-1.521-1.774-3.043c0.422-2.198,1.436-3.383,2.703-3.383c1.183,0,1.859,0.676,1.69,1.86H-143.445z  M-139.219,553.378l0.676-3.889l0.251-1.774l0.086-1.693h0.084l0.76,7.356h2.618l3.297-7.356h0.083l-0.592,2.029l-0.335,1.776 l-0.593,3.551h3.294l2.028-11.412h-4.479l-3.293,7.102l-0.76-7.102h-4.479l-2.028,11.412H-139.219z M-123.759,553.378l0.676-3.889 l0.252-1.774l0.17-1.693l0,0l0.76,7.356h2.621l3.377-7.356l0,0l-0.505,2.029l-0.422,1.776l-0.593,3.551h3.381l2.027-11.412h-4.564 l-3.21,7.102l-0.76-7.102h-4.562l-1.942,11.412H-123.759z M-107.623,553.378l2.028-11.412h-3.718l-2.025,11.412H-107.623z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-110.916,560.058l0.844-0.087c0.083,0.422,0.254,0.676,0.508,0.931c0.168,0.167,0.506,0.338,0.76,0.338 c0.422,0,0.76-0.171,1.015-0.506c0.251-0.254,0.422-0.676,0.422-1.101c0-0.506-0.171-0.847-0.422-1.101 c-0.255-0.335-0.593-0.422-1.015-0.422c-0.254,0-0.508,0.087-0.676,0.171c-0.254,0.083-0.338,0.251-0.509,0.505l-0.76-0.167 l0.677-3.381h3.209v0.76h-2.617l-0.338,1.777c0.422-0.254,0.844-0.425,1.266-0.425c0.592,0,1.014,0.254,1.438,0.593 c0.422,0.421,0.59,0.93,0.59,1.605c0,0.59-0.168,1.098-0.506,1.52c-0.422,0.509-1.015,0.764-1.774,0.764 c-0.592,0-1.014-0.171-1.436-0.509C-110.578,561.068-110.833,560.563-110.916,560.058L-110.916,560.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M-142.007,559.633v-5.24h0.676v4.648h2.534v0.592H-142.007z M-135.671,558.364l0.676,0.087 c-0.084,0.422-0.254,0.757-0.592,0.928c-0.254,0.254-0.592,0.338-1.014,0.338c-0.592,0-1.014-0.168-1.352-0.509 c-0.338-0.335-0.422-0.844-0.422-1.433c0-0.676,0.084-1.102,0.422-1.439c0.338-0.422,0.76-0.592,1.269-0.592 c0.505,0,0.93,0.17,1.268,0.506c0.338,0.341,0.506,0.85,0.506,1.525c0,0,0,0.08,0,0.168h-2.872c0.084,0.338,0.167,0.676,0.338,0.93 c0.251,0.168,0.506,0.335,0.844,0.335c0.17,0,0.422-0.081,0.592-0.251C-135.841,558.873-135.754,558.703-135.671,558.364 L-135.671,558.364z M-137.699,557.351h2.112c-0.084-0.251-0.167-0.506-0.254-0.677c-0.251-0.254-0.505-0.338-0.843-0.338 c-0.254,0-0.509,0.084-0.676,0.255C-137.615,556.758-137.699,557.013-137.699,557.351L-137.699,557.351z M-133.305,559.633 l-1.438-3.805h0.676l0.847,2.282c0.084,0.254,0.168,0.509,0.254,0.763c0.084-0.17,0.084-0.422,0.252-0.676l0.847-2.369h0.589 l-1.436,3.805H-133.305z M-128.237,558.364l0.593,0.087c-0.084,0.422-0.254,0.757-0.509,0.928 c-0.338,0.254-0.676,0.338-1.098,0.338c-0.59,0-1.014-0.168-1.353-0.509c-0.251-0.335-0.422-0.844-0.422-1.433 c0-0.676,0.171-1.102,0.422-1.439c0.339-0.422,0.763-0.592,1.269-0.592s0.931,0.17,1.269,0.506c0.338,0.341,0.506,0.85,0.506,1.525 c0,0,0,0.08,0,0.168h-2.872c0.084,0.338,0.168,0.676,0.422,0.93c0.17,0.168,0.422,0.335,0.76,0.335 c0.254,0,0.422-0.081,0.592-0.251C-128.491,558.873-128.404,558.703-128.237,558.364L-128.237,558.364z M-130.349,557.351h2.111 c-0.083-0.251-0.167-0.506-0.254-0.677c-0.251-0.254-0.506-0.338-0.844-0.338c-0.254,0-0.506,0.084-0.676,0.255 C-130.265,556.758-130.349,557.013-130.349,557.351L-130.349,557.351z M-126.969,559.633v-5.24h0.677v5.24H-126.969z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#221F20",
    d: "M-102.382,529.204c1.355,0,2.537,1.099,2.537,2.537 c0,1.352-1.182,2.536-2.537,2.536c-1.436,0-2.534-1.185-2.534-2.536C-104.916,530.303-103.817,529.204-102.382,529.204 L-102.382,529.204z M-102.382,529.713c1.101,0,2.031,0.93,2.031,2.028c0,1.098-0.931,2.028-2.031,2.028 c-1.098,0-2.025-0.931-2.025-2.028C-104.407,530.643-103.479,529.713-102.382,529.713L-102.382,529.713z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#221F20",
    d: "M-102,531.189c0-0.087,0-0.087,0-0.168 c0,0-0.084-0.087-0.171-0.087c0,0-0.084-0.083-0.168-0.083c0,0-0.083,0-0.17,0h-0.338v0.76h0.338c0.087,0,0.17-0.084,0.254-0.084 s0.084,0,0.171,0c0-0.084,0.084-0.084,0.084-0.171C-102,531.356-102,531.273-102,531.189L-102,531.189z M-101.324,533.05h-0.593 l-0.676-1.101h-0.254v1.101h-0.59v-2.624h1.182c0.084,0,0.255,0,0.338,0c0.339,0.087,0.593,0.426,0.593,0.677 c0,0.425-0.171,0.763-0.593,0.847L-101.324,533.05z"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M59.593,56.854H4.41 c-1.567,0-2.775,1.234-2.775,2.803c0,1.517,1.234,2.726,2.775,2.726h55.183c1.518,0,2.75-1.209,2.75-2.726 C62.343,58.088,61.11,56.854,59.593,56.854L59.593,56.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M7.829,49.679c-1.517,0-2.725,1.209-2.725,2.777 c0,1.517,1.208,2.751,2.725,2.751h48.295c1.516,0,2.801-1.234,2.801-2.751c0-1.568-1.285-2.777-2.801-2.777h-0.669v-24.84h0.669 c0.796,0,1.361-0.617,1.361-1.415c0-0.72-0.565-1.363-1.361-1.363H7.829c-0.721,0-1.362,0.644-1.362,1.363 c0,0.798,0.642,1.415,1.362,1.415h0.694v24.84H7.829L7.829,49.679z M49.93,24.839v24.84h-8.302v-24.84H49.93z M36.101,24.839v24.84 h-8.249v-24.84H36.101z M14.049,24.839h8.303v24.84h-8.303V24.839z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M4.41,19.566h55.183l0,0 c1.518,0,2.776-1.233,2.776-2.726c0-1.234-0.771-2.263-1.851-2.647L33.12,1.875c-0.72-0.334-1.542-0.334-2.236,0l-27.63,12.42 c-1.183,0.54-1.825,1.852-1.568,3.111C1.969,18.693,3.1,19.566,4.41,19.566L4.41,19.566z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "8.523,24.839 31.989,22.061  55.455,24.839  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "7.829,22.061 31.989,24.839  56.124,22.061  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "14.049,49.679 8.523,37.259  14.049,24.839  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "22.352,24.839 27.852,37.259  22.352,49.679  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "27.852,24.839 22.352,37.259  27.852,49.679  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "8.523,24.839 14.049,37.259  8.523,49.679  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "36.101,24.839 41.628,37.259  36.101,49.679  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "41.628,24.839 36.101,37.259  41.628,49.679  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "49.93,24.839 55.455,37.259  49.93,49.679  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "55.455,24.839 49.93,37.259  55.455,49.679  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "4.41,56.854 4.41,62.382 32.015,56.854  59.593,62.382 59.593,56.854 32.015,62.382  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "59.593,13.78 59.593,19.566  46.819,8.021 32.015,19.566 17.057,8.072 4.41,19.566 4.514,13.729  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: 31.887,
    y1: 1.617,
    x2: 31.887,
    y2: 19.566
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: 8.523,
    y1: 49.679,
    x2: 14.049,
    y2: 49.679
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: 22.352,
    y1: 49.679,
    x2: 27.852,
    y2: 49.679
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: 36.101,
    y1: 49.679,
    x2: 41.628,
    y2: 49.679
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: 49.93,
    y1: 49.679,
    x2: 55.455,
    y2: 49.679
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: 8.523,
    y1: 24.839,
    x2: 14.049,
    y2: 24.839
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: 22.352,
    y1: 24.839,
    x2: 27.852,
    y2: 24.839
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: 36.101,
    y1: 24.839,
    x2: 41.628,
    y2: 24.839
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    x1: 49.93,
    y1: 24.839,
    x2: 55.455,
    y2: 24.839
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1C76BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    points: "7.829,49.679 7.829,55.207  31.887,49.679 55.918,55.207 55.918,49.679 31.887,55.207  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking4);
export default __webpack_public_path__ + "static/media/working4.b54574a7d612c2303c9dd489c6ee0369.svg";
export { ForwardRef as ReactComponent };